import React from 'react';
import styled from 'styled-components';
import { Overlay } from 'react-bootstrap';
import useOnclickOutside from 'react-cool-onclickoutside';
import dt from '../../../shared/theme';
import {
  Button,
  Container,
  Description,
  HintTooltip,
  Title,
} from '../../shared/hint/styles';

const SHintTooltip = styled(HintTooltip)`
  inset: 18px auto auto 10px !important;

  & > .arrow {
    top: -18px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid ${props => dt(props).theme.bodyColor};
    left: calc(100% - ${props => (dt(props).theme.isMobile ? '28px' : '42px')}) !important;
    transform: none !important;
  }
`;

const Hint = React.forwardRef((_props, ref) => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setShow(true), 1000);
  }, []);

  const hide = e => {
    e && e.preventDefault() && e.stopPropagation();

    setShow(false);
  };

  const hintRef = useOnclickOutside(() => {
    hide();
  });

  return (
    <div ref={hintRef}>
      <Overlay target={ref.current} show={show} placement="bottom-end">
        {props => (
          <SHintTooltip className="ignore-onclickoutside" {...props}>
            <Container>
              <Title>
                You can now &ldquo;save&rdquo; wires
                <span className="icon-lw icon-lw-info-circle" />
              </Title>
              <Description>
                Save wires by clicking/tapping on the save icon
                located at the top and bottom of a wire.
              </Description>
              <Button onClick={hide}>Got it</Button>
            </Container>
          </SHintTooltip>
        )}
      </Overlay>
    </div>
  );
});

export default Hint;
